<template>
  <div class="user_info_view">
    <div class="user_info_head">
      <div class="deco">
        <h2 v-if="userInfo.businessType === 2">개인 사업자 정보 수정</h2>
        <h2 v-else>법인 사업자 정보 수정</h2>
        <p>
          사업자 정보를 변경하시면, 필요 서류를 다시 메일로 보내주셔야 하며, 서류를 검토하여 승인 처리를 해드립니다.<br />서류
          및 정보가 유효하지 않을 경우 신청이 거절 될 수 있습니다.<br />
          <span><v-icon clsName="icon_exclamation3" />업체가 완전히 변경된 경우는 [사업자변경]으로 신청해주세요</span>
        </p>
        <div class="bt">
          <v-button @handleClick="handleClick()" text="사업자 변경 신청" class="btn09" iconClass="icon_list"></v-button>
        </div>
      </div>
    </div>
    <div class="user_info_body">
      <div class="deco">
        <modify-business-info @update="(val) => (businessInfo = val)"></modify-business-info>

        <register-account
          @update="(val) => (account = val)"
          :businessLicenseNumber="userInfo.businessLicenseNumber"
          :businessType="userInfo.businessType"
          description="업체명의 혹은 대표자명의 계좌번호만 신청이 가능합니다."
        ></register-account>

        <required-documents :businessType="userInfo.businessType"></required-documents>

        <div class="bt bt50">
          <v-button @handleClick="handleCancel()" class="btn02" text="취소" />
          <v-button
            @handleClick="handleSubmit()"
            class="btn01"
            text="수정 신청"
            :disabled="!businessInfo.isState || !account.isState"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VIcon from '@/components/atoms/VIcon';
import VButton from '@/components/atoms/VButton';
import ModifyBusinessInfo from '@/components/modules/userInfo/ModifyBusinessInfo';
import RegisterAccount from '@/components/modules/userInfo/RegisterAccount';
import RequiredDocuments from '@/components/modules/userInfo/RequiredDocuments';

export default {
  components: {
    VIcon,
    VButton,
    ModifyBusinessInfo,
    RegisterAccount,
    RequiredDocuments,
  },
  data() {
    return {
      businessInfo: {},
      account: {},
    };
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
  },
  methods: {
    ...mapActions('modal', ['openModal']),
    ...mapActions('userInfo', ['setModifyBusinessAccount']),
    handleClick() {
      if (this.userInfo.status !== 0 && this.userInfo.status !== 1) {
        this.$router.replace({ name: 'UserInfoChange' });
      } else {
        this.openModal({
          type: 'alert',
          message: '아직 처리되지 않은 사업자 신청 내역이 있습니다.<br>처리 완료 후 다시 신청이 가능합니다.​',
        });
      }
    },
    handleCancel() {
      this.$router.replace({ name: 'UserInfoView' });
    },
    async handleSubmit() {
      const apiReturn = await this.setModifyBusinessAccount({
        ...this.businessInfo.request,
        ...this.account.request,
        businessType: this.userInfo.businessType,
      });
      if (apiReturn === 0) {
        this.openModal({
          type: 'alert',
          header: '신청이 완료되었습니다.',
          message:
            '사업자 등록증 사본 / 통장 사본 / 인감 증명서 / 계좌 확인서를 rewardpoint_biz@nexon.co.kr 로 보내주시면 ​서류를 검토 후 승인처리를 해드립니다. ​ <br/>처리결과는 내정보>사업자 처리 내역에서 확인 하실 수 있습니다.',
          callback: () => {
            this.$router.replace({ name: 'UserInfoView' });
          },
        });
      }
    },
  },
};
</script>

<style></style>
